import icon from "@material-ui/icons/MoneyOff";

export const InvoiceIcon = icon;

export default {
  icon
};
